"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var commons_1 = require("../../core/commons");

var utils_1 = require("../../core/utils");

var ReleaseImpactDTO_1 = require("../model/ReleaseImpactDTO");

var ReleaseImpactDTOConverter_1 = require("./ReleaseImpactDTOConverter");
/**
 * Default implementation of {@link ReleaseImpactDTOConverter}
 *
 * @author Adam Drda
 */


var ReleaseImpactDTOConverterImpl =
/*#__PURE__*/
function (_ReleaseImpactDTOConv) {
  _inherits(ReleaseImpactDTOConverterImpl, _ReleaseImpactDTOConv);

  function ReleaseImpactDTOConverterImpl() {
    _classCallCheck(this, ReleaseImpactDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseImpactDTOConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseImpactDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ReleaseImpactDTO_1.ReleaseImpactDTO(ReleaseImpactDTO_1.ReleaseImpactDTO.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), ReleaseImpactDTO_1.ReleaseImpactDTO.schema.daysDiff.valueOf(conversions.toClassReferenceId(source.daysDiff)), utils_1.Utils.isValueMissing(source.profitDiff) ? null : ReleaseImpactDTO_1.ReleaseImpactDTO.schema.profitDiff.valueOf(conversions.toBigNumber(source.profitDiff)), utils_1.Utils.isValueMissing(source.revenueDiff) ? null : ReleaseImpactDTO_1.ReleaseImpactDTO.schema.revenueDiff.valueOf(conversions.toBigNumber(source.revenueDiff)), utils_1.Utils.isValueMissing(source.salesVolumeDiff) ? null : ReleaseImpactDTO_1.ReleaseImpactDTO.schema.salesVolumeDiff.valueOf(conversions.toBigNumber(source.salesVolumeDiff)), utils_1.Utils.isValueMissing(source.marginDiff) ? null : ReleaseImpactDTO_1.ReleaseImpactDTO.schema.marginDiff.valueOf(conversions.toBigNumber(source.marginDiff)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return commons_1.UNIMPLEMENTED('ReleaseImpactDTOConverterImpl.toDocument');
    }
  }]);

  return ReleaseImpactDTOConverterImpl;
}(ReleaseImpactDTOConverter_1.ReleaseImpactDTOConverter);

exports.ReleaseImpactDTOConverterImpl = ReleaseImpactDTOConverterImpl;